import React, { useEffect, useState } from "react";
import {
  Nav,
  Modal,
  SelectPicker,
  Container,
  Button,
  Message,
  Tag,
} from "rsuite";
import { EraIcon } from "../../styles/Icon.js";
//import { getUserInfo, getUserRoles } from "../../azure/MSGraphService.js";
import { appRoleMap } from "../../azure/authConfig.js";
//import { getActiveRole, setActiveRole } from "./CookieManager.js";
//import { clearCookies } from "./CookieManager.js";
import { login, logout } from "../../auth/session.js";

export const RolesModal = ({
  open,
  onClose,
  userRoles,
  userRolesCompany,
  activeRole,
  setRole,
}) => {
  const [roleModal, setRoleModal] = useState();
  const [representedIMModal, setRepresentedIMModal] = useState(null);
  const [representedIMCode, setRepresentedIMCode] = useState(null);
  const [roleList, setRoleList] = useState([]);
  const [imList, setIMList] = useState([]);
  const [ready, setReady] = useState(false);

  const roleNames = {
    nre: {
      label: "NRE - National Registration Entity",
      value: "nre",
    },
    im: { label: "IM - Infrastructure Manager", value: "im" },
    ru: { label: "RU - Railway Undertaking", value: "ru" },
  };

  const renderMenuItem = (label, item) => {
    return (
      <>
        <b>{label}</b>
        {item.country && <i style={{ marginLeft: "10px" }}>{item.country}</i>}
      </>
    );
  };

  useEffect(() => {
    let isReady = false;
    if (roleModal === "im" || roleModal === "ru") {
      isReady = true;
    } else if (roleModal === "nre") {
      if (representedIMModal) {
        isReady = true;
      }
    }
    setReady(isReady);
  }, [roleModal, representedIMModal]);

  useEffect(() => {
    let newRoleList = [];
    let newIMList = [];

    if (userRoles !== undefined) {
      for (let role of Object.keys(userRoles)) {
        if (userRoles[role] === true) {
          if (userRolesCompany?.org?.country?.name !== undefined) {
            newRoleList.push({
              country: userRolesCompany?.org?.country?.name,
              ...roleNames[role],
            });
          } else {
            newRoleList.push(roleNames[role]);
          }
        }
      }
    }

    if (userRolesCompany?.im !== undefined) {
      for (let im of userRolesCompany?.im) {
        //console.log(im);

        newIMList.push({
          label: im?.name,
          code: im?.code,
          country: im.country?.name,
          value: im?.id,
        });
      }
    }

    newIMList.sort((a, b) => a.label.localeCompare(b.label));

    setRoleList(newRoleList);
    setIMList(newIMList);
  }, [userRoles]);

  const onSetRole = (item) => {
    setRoleModal(item);
    //console.log(item);
  };

  const onSetIm = (selectedValue) => {
    const selectedItem = imList.find((item) => item.value === selectedValue);
    setRepresentedIMModal(selectedValue); // selected im ID
    setRepresentedIMCode(selectedItem?.code || ""); // im code
  };

  const onApplyChanges = () => {
    // For IM and RU roles, use the user's organization (company.org)
    // For NRE role, use the selected represented IM

    if (roleModal === "im") {
      setRole(
        roleModal,
        "Infrastructure Manager",
        userRolesCompany?.org?.code || ""
      );
    } else if (roleModal === "ru") {
      console.log("Setting RU role:", userRolesCompany);
      setRole(
        roleModal,
        "Railway Undertaking",
        userRolesCompany?.org?.code || ""
      );
    } else {
      // NRE case: use the selected represented IM
      setRole(roleModal, representedIMModal, representedIMCode);
    }

    onClose();
  };

  return (
    <Modal size={"sm"} open={open} onClose={onClose}>
      <Modal.Header>
        <Modal.Title>Select user role</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container style={{ marginBottom: "10px" }}>
          <Message showIcon type="info" style={{ marginBottom: "15px" }}>
            Select the user role you want to use in the RINF Apps.
          </Message>
          <SelectPicker
            placeholder={"Select user role"}
            data={roleList}
            value={roleModal}
            block
            renderMenuItem={renderMenuItem}
            onSelect={onSetRole}
            style={{ marginBottom: "10px" }}
          />

          {roleModal == "nre" && (
            <SelectPicker
              placeholder={"Select represented IM"}
              data={imList}
              value={representedIMModal}
              block
              renderMenuItem={renderMenuItem}
              onSelect={onSetIm}
              style={{ marginBottom: "10px" }}
            />
          )}
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} appearance="subtle">
          Cancel
        </Button>
        <Button
          onClick={onApplyChanges}
          appearance="primary"
          color={"green"}
          disabled={!ready}
        >
          Change role
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export const SignInButton = () => (
  <Nav.Item onClick={() => login()}>Sign in</Nav.Item>
);

export const SignOutButton = () => (
  <Nav.Item
    onClick={() => logout()}
    icon={<EraIcon faName="right-from-bracket" />}
  >
    Sign out
  </Nav.Item>
);

export const UserMenu = ({
  userInfo,
  userRoles,
  userRolesCompany,
  isAuthenticated,
  activeRole,
  setRole,
}) => {
  const [openRoleModal, setOpenRoleModal] = useState();

  useEffect(() => {
    //console.log(isAuthenticated, activeRole);
    if (isAuthenticated && activeRole?.role === null) {
      setOpenRoleModal(true);
    }
  }, [isAuthenticated, activeRole]);

  //console.log(isAuthenticated);

  const getUserString = () => {
    if (!isAuthenticated || !activeRole?.role) {
      return "";
    }

    const { role, company } = activeRole;
    const representedImName = userRolesCompany?.im?.find(
      (im) => im.id === company,
    )?.name;

    if (role === "nre") {
      return (
        <>
          {userRolesCompany?.org?.name} <b>&nbsp;/&nbsp;</b>
          {representedImName || "Represented IM not found"}
          <span style={{ marginLeft: "6px" }}>
            (code: {activeRole?.code || "Code not found"})
          </span>
        </>
      );
    }
    if (role === "im") {
      let imName = userRolesCompany?.org?.name;
      let imCode = userRolesCompany?.org?.code;
      return (
        <>
          {imName || "IM not found"}
          <span style={{ marginLeft: "6px" }}>
            (code: {imCode || "Code not found"})
          </span>
        </>
      );
    }
    if (role === "ru") {
      let ruName = userRolesCompany?.org?.name;
      let ruCode = userRolesCompany?.org?.code;
      console.log(userRolesCompany);

      return (
        <>
          {ruName || "RU not found"}
          <span style={{ marginLeft: "6px" }}>
            (code: {ruCode || "Code not found"})
          </span>
        </>
      );
    }
    return "";
  };

  return (
    <>
      {isAuthenticated && (
        <RolesModal
          open={openRoleModal}
          onClose={() => {
            setOpenRoleModal(false);
          }}
          userRolesCompany={userRolesCompany}
          userRoles={userRoles}
          activeRole={activeRole}
          setRole={setRole}
        />
      )}

      <Nav.Menu
        active={isAuthenticated === true}
        title={getUserString()}
        icon={<EraIcon faName="user" />}
      >
        {isAuthenticated && (
          <>
            {activeRole?.role === "nre" && (
              <>
                <Nav.Item
                  disabled
                  active
                  icon={<EraIcon faName="earth-europe" />}
                >
                  {"Organisation Role: Registration Entity"}
                </Nav.Item>

                {activeRole?.company !== null && (
                  <Nav.Item disabled active icon={<EraIcon faName="train" />}>
                    <>
                      {"Acting as: " +
                        userRolesCompany?.im?.find(
                          (im) => im.id === activeRole?.company,
                        )?.name}
                      <span style={{ marginLeft: "6px" }}>
                        (code: {activeRole?.code || "Code not found"})
                      </span>
                    </>
                  </Nav.Item>
                )}
              </>
            )}

            {activeRole?.role === "im" && (
              <Nav.Item
                disabled
                active
                icon={<EraIcon faName="earth-europe" />}
              >
                {"Organisation role: Infrastructure Manager"}
              </Nav.Item>
            )}

            {activeRole?.role === "ru" && (
              <>
                <Nav.Item
                  disabled
                  active
                  icon={<EraIcon faName="earth-europe" />}
                >
                  {"Organisation Role: Railway Undertaking"}
                </Nav.Item>
              </>
            )}

            <Nav.Item
              style={{
                padding: "0px",
                height: "5px",
                borderBottom: "1px dotted #c5c6c7",
              }}
            >
              <br></br>
            </Nav.Item>

            <Nav.Item disabled icon={<EraIcon faName="user" />}>
              {userInfo?.displayName}
            </Nav.Item>
            <Nav.Item disabled>{userInfo?.mail}</Nav.Item>
            {userInfo?.userRoles?.active && (
              <Nav.Item disabled>{userInfo?.userRoles?.active}</Nav.Item>
            )}
            <Nav.Item
              disabled
              style={{
                padding: "0px",
                height: "5px",
                borderBottom: "1px dotted #c5c6c7",
              }}
            >
              <br></br>
            </Nav.Item>
            <Nav.Item
              icon={<EraIcon faName="repeat" />}
              onClick={() => {
                setOpenRoleModal(true);
              }}
            >
              Change role
            </Nav.Item>
          </>
        )}

        {isAuthenticated ? (
          <SignOutButton />
        ) : (
          <>
            <SignInButton />
            <Nav.Item as={"a"} href="https://srm-portal.powerappsportals.com/">
              Reset Password
            </Nav.Item>
          </>
        )}
      </Nav.Menu>
    </>
  );
};
